(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Markdown", [], factory);
	else if(typeof exports === 'object')
		exports["Markdown"] = factory();
	else
		root["Markdown"] = factory();
})(window, function() {
return 